import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { responderClearReset } from '../store/slices/responderSlice';
import { sosFetch } from '../utils/sosApi';
import '../css/login.css';

export default function ResponderChangePasswordPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [current, setCurrent] = useState('');
  const [next,    setNext]    = useState('');
  const [confirm, setConfirm] = useState('');
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (next.length < 6) { setError('New password must be at least 6 characters'); return; }
    if (next !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      const res = await sosFetch('/sos/auth/change-password', {
        method: 'POST',
        json:   { current_password: current, new_password: next },
      });
      if (!res.ok) {
        const d = await res.json();
        setError(d.detail || 'Failed to change password');
        return;
      }
      dispatch(responderClearReset());
      navigate('/responder/sos', { replace: true });
    } catch {
      setError('Cannot reach SOS service — check connection');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pk-login-root login-page">
      <div className="login-card" style={{ borderColor: 'rgba(230,57,70,0.3)' }}>
        <div className="login-brand">
          <div className="login-logo" style={{ background: 'rgba(230,57,70,0.1)', borderColor: 'rgba(230,57,70,0.3)' }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#e63946" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>
          <div className="login-brand-name">PARVEKSHAK</div>
          <div className="login-brand-sub" style={{ color: '#e63946', opacity: 1 }}>
            Set Responder Password
          </div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label>Current Password</label>
            <div className="login-input-wrap">
              <span className="login-input-icon">🔒</span>
              <input
                className="login-input"
                type="password"
                placeholder="Enter current password"
                value={current}
                onChange={e => setCurrent(e.target.value)}
                autoFocus
                required
              />
            </div>
          </div>
          <div className="login-field">
            <label>New Password</label>
            <div className="login-input-wrap">
              <span className="login-input-icon">🔑</span>
              <input
                className="login-input"
                type="password"
                placeholder="At least 6 characters"
                value={next}
                onChange={e => setNext(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="login-field">
            <label>Confirm New Password</label>
            <div className="login-input-wrap">
              <span className="login-input-icon">🔑</span>
              <input
                className="login-input"
                type="password"
                placeholder="Confirm new password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
              />
            </div>
          </div>

          {error && <div className="login-error"><span>⚠️</span> {error}</div>}

          <button
            className="login-btn"
            type="submit"
            disabled={loading}
            style={{ background: '#e63946' }}
          >
            {loading ? 'Updating…' : 'Set New Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
